module.exports = __webpack_public_path__ + "assets/img/xygl__d_4.245856d3.png";